import redirectAcesso from "../middleware/rematricula/redirectAcesso";
import carregaSelecaoDisciplinas from "../middleware/rematricula/carregaSelecaoDisciplinas";

const breadcrumb = [
  { name: "IntegradON", link: process.env.INTERNO_URL },
  { name: "Alteração de Matrícula", link: "/alteracao-matricula" }
];

const Home = () => import("../components/Views/Home.vue");
const LoginRematricula = () =>
  import("../components/Views/Rematricula/Login.vue");
const View = () => import("../components/Views/Rematricula/View.vue");
const ConfiguracaoAmbiente = () =>
  import("../components/Views/Rematricula/ConfiguracaoAmbiente.vue");
const Inicio = () => import("../components/Views/Rematricula/Inicio.vue");
const Etapa = () => import("../components/Views/Rematricula/Etapa.vue");
const CadastroFinanceiro = () =>
  import("../components/Views/Rematricula/Etapas/CadastroFinanceiro.vue");
const CadastroAcademico = () =>
  import("../components/Views/Rematricula/Etapas/CadastroAcademico.vue");
const VerificacaoCadastral = () =>
  import("../components/Views/Rematricula/Etapas/VerificacaoCadastral.vue");
const EnvioDocumentos = () =>
  import("../components/Views/Rematricula/Etapas/EnvioDocumentos.vue");
const EmissaoContrato = () =>
  import("../components/Views/Rematricula/Etapas/EmissaoContrato.vue");
const EmissaoContratoServicos = () =>
  import("../components/Views/Rematricula/Etapas/EmissaoContratoServicos.vue");
const EntregaDocumentacao = () =>
  import("../components/Views/Rematricula/Etapas/EntregaDocumentacao.vue");
const SelecaoDisciplinas = () =>
  import("../components/Views/AlteracaoMatricula/SelecaoDisciplinas.vue");
const Acesso = () => import("../components/Views/Rematricula/Acesso.vue");
const Validacao = () =>
  import("../components/Views/Rematricula/Acesso/Validacao.vue");
const Solicitacao = () =>
  import("../components/Views/Rematricula/Acesso/Solicitacao.vue");
const Ajuda = () => import("../components/Views/Rematricula/Ajuda.vue");
const CadastroFiador = () =>
  import("../components/Views/Rematricula/Etapas/CadastroFiador.vue");

const rematricula = [
  {
    path: "/rematricula/",
    redirect: "/rematricula/login"
  },
  {
    path: "/rematricula/login",
    component: LoginRematricula
  },
  {
    path: "/rematricula/login/:cpf/:nascimento",
    component: LoginRematricula
  },
  {
    path: "/rematricula/login/:cpf/:nascimento/:codigoAcesso",
    component: LoginRematricula
  },
  {
    path: "/rematricula/login/:cpf/:nascimento/:codigoAcesso/:responsavel",
    component: LoginRematricula
  },
  {
    path: "/rematricula/configuracao-ambiente",
    component: ConfiguracaoAmbiente
  },
  {
    path: "/rematricula/ajuda",
    component: Ajuda
  },
  {
    path: "/rematricula/view/:id",
    component: Home,
    children: [
      {
        path: "/",
        name: "Visualização de Rematrícula",
        component: View,
        breadcrumb
      }
    ]
  },
  {
    path: "/rematricula/view/:id/:print",
    component: Home,
    children: [
      {
        path: "/",
        name: "Impressão de Rematrícula",
        component: View,
        breadcrumb
      }
    ]
  },
  {
    path: "/rematricula/inicio",
    component: Inicio
  },
  {
    path: "/rematricula/acesso",
    component: Acesso,
    name: "Confirmação",
    children: [
      {
        path: "/rematricula/acesso/",
        redirect: "/rematricula/acesso/validacao"
      },
      {
        path: "validacao",
        name: "Validar Código de Acesso",
        component: Validacao,
        middleware: redirectAcesso
      },
      {
        path: "validacao/:codigoAcesso",
        name: "Validar Código de Acesso Existente",
        component: Validacao
      },
      {
        path: "solicitacao",
        name: "Solicitar Código de Acesso",
        component: Solicitacao
      }
    ]
  },
  {
    path: "/rematricula/etapa",
    name: "Etapa",
    component: Etapa,
    children: [
      {
        path: "cadastro-academico",
        name: "Atualização do Aluno",
        component: CadastroAcademico
      },
      {
        path: "cadastro-financeiro",
        name: "Atualização do Responsável Financeiro",
        component: CadastroFinanceiro
      },
      {
        path: "verificacao-cadastral",
        name: "Verificação Cadastral",
        component: VerificacaoCadastral
      },
      {
        path: "envio-documentos",
        name: "Envio de Documentos",
        component: EnvioDocumentos
      },
      {
        path: "emissao-contrato",
        name: "Emissão do Contrato",
        component: EmissaoContrato
      },
      {
        path: "emissao-contrato-servicos",
        name: "Emissão do Contrato com Serviços",
        component: EmissaoContratoServicos
      },
      {
        path: "entrega-documentacao",
        name: "Entrega de Documentação",
        component: EntregaDocumentacao
      },
      {
        path: "selecao-disciplinas",
        name: "Seleção de Disciplinas",
        component: SelecaoDisciplinas,
        meta: {
          middleware: carregaSelecaoDisciplinas
        }
      },
      {
        path: "cadastro-fiador",
        name: "Atualização do Fiador",
        component: CadastroFiador
      }
    ]
  }
];

export default rematricula;



// WEBPACK FOOTER //
// ./src/routes/rematricula.js